import React from 'react';
import '../Services.css';
import Image1 from '../../Gemco-Website-Images/Services/Building_renovation.jpg';

const Service_four = () => {
  return (
    <div className='wp_sub_service'>
      <div className="container wp_sub_service_container">
          <div className="row wp_service_row">
            <div className="content-column">
              <div className="inner-column wp_service_inner_column">
                <div className='sec-title forseotitle wp_service_sec_title'>
                  <h1>Retrofit and Refurbishment Works</h1>
                  <p>Full MEP retrofit capability for occupied or recently vacated buildings — hotels, malls, offices
                    and commercial facilities. Complex scope requiring detailed planning, phased execution and
                    minimum disruption to ongoing operations. Works coordinated around tenant and operator
                    schedules.</p>
                    <ul>
                      <li className="service_list_item">CHW piping rerouting and full system upgrades</li>
                      <li className="service_list_item">Ducting modifications and new duct runs</li>
                      <li className="service_list_item">Replacement of chillersupgrades</li>
                      <li className="service_list_item">cooling towers</li>
                      <li className="service_list_item">pumps, AHUs and FCUs</li>
                      <li className="service_list_item">Electrical upgrades</li>
                      <li className="service_list_item">panel replacements and capacity increases</li>
                      <li className="service_list_item">Flooring works: core cutting, chasing and reinstatement</li>
                      <li className="service_list_item">Acoustic and insulation works</li>
                      <li className="service_list_item">Full testing, commissioning and handover</li>
                    </ul>
                </div>
              </div>
            </div>
            <div className="image-column">
              <img src={Image1} width="500" height="400" alt="" />
            </div>
          </div>
      </div>
    </div>
  )
}

export default Service_four